import { FC, useCallback, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SmartConnectorContext } from '../../context';
import { StyledSQLVersionSelect } from './styles';
import { SQL_SCRIPT_STATUSES } from 'pages/SmartConnectors/constants';
import { GenericOption, SQLScriptStatus } from 'pages/SmartConnectors/types';
import { useErrors } from 'pages/SmartConnectors/SmartConnector/hooks/useErrors';

type SQLVersionSelectProps = {
  view: SQLScriptStatus;
};

export const SQLVersionSelect: FC<SQLVersionSelectProps> = ({ view }) => {
  const { t } = useTranslation();
  const { stepData, setStepData, metaData } = useContext(SmartConnectorContext);

  const { clearError, validate, error } = useErrors('sql_version');

  const sqlVersionOptions = useMemo(
    () =>
      metaData.sql_versions.map((version) => ({
        value: version,
        label: `chdb ${version}`,
      })),
    [metaData.sql_versions]
  );

  const handleChangeSqlVersion = useCallback(
    ({ value }: GenericOption) => {
      clearError();
      setStepData((prev) => ({
        ...prev,
        last_draft_script: {
          ...prev.last_draft_script,
          user_script: prev.last_draft_script?.user_script || '',
          sql_version: value,
        },
      }));
    },
    [setStepData, clearError]
  );

  return (
    <StyledSQLVersionSelect
      value={
        view === SQL_SCRIPT_STATUSES.draft
          ? stepData.last_draft_script?.sql_version
          : stepData.live_script?.sql_version
      }
      options={sqlVersionOptions}
      onChange={handleChangeSqlVersion}
      placeholder={t('Select SQL Version')}
      disabled={view === SQL_SCRIPT_STATUSES.live}
      error={error}
      validate={validate}
    />
  );
};
